import { render, staticRenderFns } from "./MessageButtonComponent.vue?vue&type=template&id=4cae127f"
import script from "./MessageButtonComponent.vue?vue&type=script&lang=js"
export * from "./MessageButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./MessageButtonComponent.vue?vue&type=style&index=0&id=4cae127f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports